import React from 'react';
import { connect } from 'react-redux';
import { goTo } from "../tools";

const mapState = (state) => {
    return {
        preguntaUno: state.miPerfil.preguntaUno,
        preguntaDos: state.miPerfil.preguntaDos
    };
}

const mapDispatch = (dispatch) => {
    return {}
}


class Seguridad extends React.Component {

    cambiarContra = () => {
        goTo("cambiar-contrasena");
    }
    


	render() {
		return <div className="col-xs-12">
            <div className="card perfil-card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-xs-12">
                            <i><img src={ require("../img/icon-seguridad.svg") } /></i><b>Seguridad</b>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <p>Al modificar tu contraseña los cambios se verán reflejados en la app Soy Cliente GNP.</p>
                    </div>
                    <div className="col-xs-12 mt-25">
                        <div className="row">
                            <div className="col-xs-6">
                                <p>Modificar tu contraseña</p>
                            </div>
                            <div className="col-xs-6">
                                <div className="text-right card-actions-btn">
                                    <a className="orange-btn" onClick={this.cambiarContra}>Editar <img src={ require("../img/editar-icono.png") } /></a>
                                </div>
                            </div>
                        </div>                       
                    </div>
                </div>
            </div>
        </div>
	}
}

export default connect(mapState, mapDispatch)(Seguridad);



// WEBPACK FOOTER //
// ./src/miPerfil/seguridad.cmpt.js